<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: "UserListItem",
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  methods: {
    deleteUser() {
      this.$swal.fire({
        title: this.t('alerts.warning'),
        text: this.t('asks.deleteUser'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.t('buttons.confirm'),
        cancelButtonText: this.t('buttons.cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete("/api/users/" + this.user._id).then(() => {
            this.$swal.fire({
              title: this.t('alerts.success'),
              text: this.t('messages.userDeleted'),
              icon: "success"
            });
          }).catch((e) => {
            this.$swal.fire({
              title: this.t('alerts.error'),
              text: e.response?.data?.message,
              icon: "error"
            });
          })
        }
      })
    }
  }
})
</script>

<template>
  <li class="list-group-item d-flex justify-content-between align-items-center">
    <div class="ms-2 me-auto">
      <div
        data-bs-target="#editUserModal"
        data-bs-toggle="modal"
        :data-bs-user="user._id"
        class="fw-bold"
        style="cursor: pointer;"
      >
        {{ user.username }}
      </div>
      {{ user.role.name }}
    </div>
    <span class="badge bg-primary rounded-pill">{{ user.ordersCount }}</span>
    <button class="btn btn-close position-absolute end-0 me-3" @click="deleteUser"></button>
  </li>
</template>

<style scoped lang="scss">
[data-bs-target="#editUserModal"] {
  cursor: pointer;
}
</style>